import api from './axios';

export const servicesApi = {
  // Public — list active services for the picker
  list: () => api.get('/services').then((r) => r.data),

  // Admin
  adminList: () => api.get('/admin/services').then((r) => r.data),
  adminCreate: (payload) => api.post('/admin/services', payload).then((r) => r.data),
  adminUpdate: (id, payload) => api.patch(`/admin/services/${id}`, payload).then((r) => r.data),
  adminDelete: (id) => api.delete(`/admin/services/${id}`).then((r) => r.data),
};